import React from "react";
import { useTranslation } from "react-i18next";
import { Flex, Box, Text, Button } from "@chakra-ui/react";

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  onViewAll,
}) => {
  const { t } = useTranslation("common");

  return (
    <Flex align="center" justify="space-between">
      <Box>
        <Text fontWeight="700" color="#252525" fontSize="28px">
          {title}
        </Text>
        {subtitle && (
          <Text fontSize="12px" color="#5C6670">
            {subtitle}
          </Text>
        )}
      </Box>
      {onViewAll && (
        <Button
          onClick={onViewAll}
          variant="link"
          colorScheme="blue"
          fontSize="14px"
          fontWeight="medium"
          width="fit-content"
        >
          {t("dashboard.viewAll")}
        </Button>
      )}
    </Flex>
  );
};

export default SectionHeader;
